export const UTM_COOKIE_NAME = "utm_parameters";

export const UTM_COOKIE_MAX_AGE = 86400; // 1 day

export const UTM_PARAMETERS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_emailname",
];
